import { REACT_APP_API_URL } from "../configs/config";

const signIn = async (payload) => {
    const response = await fetch(`${REACT_APP_API_URL}auth/signin`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const reponseJson = await response.json();
    return reponseJson;
}

export { signIn }